import React, { useEffect, useState } from "react";
import logoSm from "../../../assets/images/logo-sm.png";
import likeImg from "../../../assets/images/like.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { redirectIntoApp } from "../../../utils/authHelper";
import axios from "../../../axios-instance";

const ThanksForPayment = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isTrial = searchParams.get("trial") === "1";
  const isFree = searchParams.get("plan") === "free";
  const [emailVerificationEnabled, setEmailVerificationEnabled] = useState(false);

  useEffect(() => {
    axios
      .get("user-details")
      .then((res) => {
        const data = res?.data?.data ?? res?.data;
        setEmailVerificationEnabled(Boolean(data?.email_verification_enabled));
      })
      .catch(() => {
        // fail silently — keep default (false = don't show email text)
      });
  }, []);

  const heading = isTrial
    ? "Your 14-day trial has started"
    : isFree
    ? "Your free workspace is ready"
    : "Thanks For Your Payment!";

  const body = isTrial
    ? null
    : isFree
    ? emailVerificationEnabled
      ? "An email has been sent to confirm your email address. You can upgrade to Standard or Teams anytime and start a 14-day trial."
      : "You can upgrade to Standard or Teams anytime and start a 14-day trial."
    : emailVerificationEnabled
    ? "An email has been sent to your email to confirm your email address."
    : null;

  return (
    <div className="main-container">
      <header>
        <div className="header-container">
          <div className="logo">
            <img src={logoSm} alt="" />
          </div>
        </div>
      </header>

      <div className="thanks page">
        <div className="page-desc">
          <img src={likeImg} alt="" />
          <h1>{heading}</h1>
          {body && <p>{body}</p>}
          <button
            className="btn btn-app"
            style={{ marginTop: 30 }}
            type="button"
            onClick={() => {
              // Keep the session and enter the app — do not clear auth (caused white screen / re-login).
              redirectIntoApp(navigate);
            }}
          >
            Let's Start Scheduling
          </button>
        </div>
      </div>

      <footer>
        <div className="footer-container">
          <ul className="languages d-none">
            <li>English (UK)</li>
            <li>हिन्दी</li>
            <li>ਪੰਜਾਬੀ</li>
            <li>বাংলা</li>
            <li>Deutsch</li>
            <li>ગુજરાતી</li>
            <li>Español</li>
          </ul>
          <p>© {new Date().getFullYear()} MeetOcto. A JB Media LLC company. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default ThanksForPayment;
